import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "../lib/api";
import { useApp } from "../context/AppContext";
import Hero from "../components/Hero";
import ServiceCard from "../components/ServiceCard";
import OfferCard from "../components/OfferCard";
import ReviewsSection from "../components/ReviewsSection";
import ContactSection from "../components/ContactSection";
import { Skeleton } from "../components/ui/skeleton";

export default function Home() {
  const { t } = useApp();
  const [services, setServices] = useState(null);
  const [offers, setOffers] = useState([]);
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => setServices([]));
    api.get("/offers").then((r) => setOffers(r.data)).catch(() => {});
    api.get("/reviews").then((r) => setReviews(r.data)).catch(() => {});
  }, []);

  return (
    <>
      <Hero />

      {/* Featured services */}
      <section className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-16 sm:py-24" data-testid="featured-services">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground">{t.home.featured}</h2>
            <p className="text-muted-foreground mt-2 text-lg">{t.home.featuredSub}</p>
          </div>
          <Link to="/services" className="hidden sm:inline-flex items-center gap-1 text-primary font-semibold hover:gap-2 transition-all">
            {t.common.viewAll} <ArrowLeft className="h-4 w-4 rtl-flip" />
          </Link>
        </div>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {services === null
            ? Array.from({ length: 4 }).map((_, i) => <Skeleton key={i} className="h-80 rounded-3xl" />)
            : services.slice(0, 4).map((s, i) => <ServiceCard key={s.id} service={s} index={i} />)}
        </div>
      </section>

      {/* Offers */}
      {offers.length > 0 && (
        <section className="bg-muted/50 py-16 sm:py-24">
          <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto">
            <div className="text-center max-w-2xl mx-auto mb-12">
              <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground">{t.home.offersTitle}</h2>
              <p className="text-muted-foreground mt-3 text-lg">{t.home.offersSub}</p>
            </div>
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
              {offers.slice(0, 3).map((o, i) => <OfferCard key={o.id} offer={o} index={i} />)}
            </div>
          </div>
        </section>
      )}

      <ReviewsSection reviews={reviews} />
      <ContactSection />
    </>
  );
}
